import React from 'react';

const SocialMediaCTA = ({ className }) => {
  return (
    <section className={`relative h-80 md:h-80 bg-cover bg-center flex items-center justify-center ${className}`} style={{ backgroundImage: "url('/hero_img/image-05.jpg')" }}>
      <div className="absolute inset-0 bg-black/60 flex flex-col items-center justify-center p-4">
        <p className="text-white text-opacity-80 text-sm mb-2 font-poppins ">
          STAY UP TO DATE
        </p>
        <h2 className="text-white text-4xl md:text-5xl font-bold mb-6 text-center font-poppins">
          Follow us on social media.
        </h2>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="https://www.facebook.com/" // Assuming LinkedIn link
            target="_blank"
            rel="noopener noreferrer"
            className="border border-white text-white px-6 py-3 rounded-full hover:bg-white hover:text-main-blue transition duration-300 ease-in-out font-poppins"
          >
            FACEBOOK
          </a>
          <a
            href="https://www.linkedin.com/" // Assuming LinkedIn link
            target="_blank"
            rel="noopener noreferrer"
            className="border border-white text-white px-6 py-3 rounded-full hover:bg-white hover:text-main-blue transition duration-300 ease-in-out font-poppins"
          >
            LINKEDIN
          </a>
          <a
            href="https://www.instagram.com/" // Assuming Instagram link
            target="_blank"
            rel="noopener noreferrer"
            className="border border-white text-white px-6 py-3 rounded-full hover:bg-white hover:text-main-blue transition duration-300 ease-in-out font-poppins"
          >
            INSTAGRAM
          </a>
        </div>
      </div>
    </section>
  );
};

export default SocialMediaCTA;